import * as entity from './base/entity.js';
import * as terrain_component from './base/render/terrain-component.js';


export const demo_builder = (() => {

  class DemoBuilder extends entity.Component {
    static CLASS_NAME = 'DemoBuilder';

    get NAME() {
      return DemoBuilder.CLASS_NAME;
    }

    constructor(params) {
      super();

      this.params_ = params;
      this.spawned_ = false;
    }

    Update(timeElapsed) {
      if (this.spawned_) {
        return;
      }

      this.spawned_ = true;

      const terrain = new entity.Entity('terrain');
      terrain.AddComponent(new terrain_component.TerrainComponent({}));
      terrain.SetActive(true);
      terrain.Init();
    }
  };

  return {
    DemoBuilder: DemoBuilder
  };

})();
